module.exports = __webpack_public_path__ + "img/xinxi.d5544c1e.png";